import { useState, useEffect } from 'react';
import { Layout, theme, Menu, type MenuProps, Modal } from 'antd';
import { useSelect, useList, CrudFilters } from '@refinedev/core';
import { PlayCircleFilled, EditFilled, PlusSquareFilled } from '@ant-design/icons';

import EditSubseccion from 'pages/infografias/editSubseccion';
import { EditComponentsPublication } from './EditComponentsPublication';
import { useModal, useModalForm } from '@refinedev/antd';
import Cw8Create from 'components/cw8/Cw8Create';
import { close } from 'inspector';
import { CreateButton } from "@refinedev/antd";
import Cw8Edit from 'components/cw8/Cw8Edit';

const { Header, Content, Footer, Sider } = Layout;

interface ICategory {
  id: number;
  sep_title: string;
}

interface ItemMenu {
  key: string
  label: string
  icon?: JSX.Element
  children?: ItemMenu[]
  type?: string
}

interface ISubCategory {
  id: string;
  sup_id_section: string;
  sup_title: string;
}

interface MenuPublicationProps {
  idPublication: number;
  setSeccion?: (id: number) => void
}

export const MenuPublication = ({ idPublication }: MenuPublicationProps) => {


  const prefijoCreateSubSeccion = 'create-sub-';
  const prefijoEditSeccion = 'edit-sec-';
  const { token: { colorBgContainer }, } = theme.useToken();
  const [secciones, setSecciones] = useState<string[]>([]);
  const [itemsMenu, setItemsMenu] = useState<ItemMenu[]>([]);
  const [idSubSection, setIdSubSection] = useState<string>();
  const [idSection, setIdSection] = useState<string>();
  const [openCreateModal, setOpenCreateModal] = useState(false);

  // const [createModalCreate, setCreateModalCreate] = useState(false);





  const { queryResult, options: optionsSections } = useSelect<ICategory>({
    resource: "sectionPub",
    optionLabel: "sep_title",
    optionValue: "id",
    filters: [
      {
        field: "sep_id_publication",
        operator: "eq",
        value: idPublication
      }
    ]
  });

  // GET INFO SUBSECCIONES DE SECCIONES DE LA INFOGRAFIA
  const { data: subSeccionesData } = useList<ISubCategory>({
    resource: "subsectionPub"
    , pagination: {
      pageSize: 100,
    }
    , filters: [
      {
        field: "sub_id_seccion",
        operator: "eq",
        value: secciones
      }
    ]
  });



  useEffect(() => {

    const subSeccionesAll = subSeccionesData?.data ?? [];
    const seccionesMenu: ItemMenu[] = optionsSections ? optionsSections.map((option, index) => ({
      key: option.value,
      icon: <PlayCircleFilled />,
      label: option.label,
      children: []
    })) : []

    const sectionWithSubsection = seccionesMenu.map((section) => {

      // New item
      const children: ItemMenu[] = [
      {
        key: `${prefijoEditSeccion}${section.key}`,
        label: '- Editar '+section.label
        , icon: <EditFilled />
      }    
      ,{
        key: `${prefijoCreateSubSeccion}${section.key}`,
        label: '+ Crear SubSección'
        , icon: <PlusSquareFilled />
      }
      , {
        key: '-',
        label: '',
        type: 'divider'
      }    
      ];

      //añadir las subsecciones
      subSeccionesAll.forEach((subsection) => {
        if (subsection.sup_id_section === section.key) {
          children.push({
            key: `${subsection.id}`,
            label: subsection.sup_title
          })
        }
      })

      return {
        ...section,
        children
      }
    })

    const seccionesTmp: string[] = optionsSections ? optionsSections.map((option, index) => (option.value)) : []
    setSecciones([seccionesTmp.join("|")])
    setItemsMenu(sectionWithSubsection)
  }, [optionsSections, subSeccionesData])


  //---------------------------------------------
  // CLICK EN EL MENÚ LATERAL
  //---------------------------------------------
  const menuClick: MenuProps['onClick'] = ({ item, key, keyPath, domEvent }) => {
    console.log(key);
    const subSectionId = parseInt(`${key}`);

    //si es un numero es editar una subsección
    if (subSectionId) {
      console.log("New Subsection ", subSectionId.toString())
      setIdSubSection(subSectionId.toString());
    } else {
        //crear una subsección
        if(key.indexOf(prefijoCreateSubSeccion) >=0 ){
            const idSectionTemp = key.replace(prefijoCreateSubSeccion, '');
            console.log("New Section ", idSectionTemp)
            setIdSection(idSectionTemp);
          }else{
            //editar una seccion
            const idSectionTemp = key.replace(prefijoEditSeccion, '');
            console.log("Edit Section ", idSectionTemp)
            editModalShow(idSectionTemp)
            // console.log("Edit Section ", idSectionTemp)
            // setIdSection(idSectionTemp);
            
        }

    }
  }


  useEffect(() => {
    if (idSection) {
      createModalShow()
    }
  }, [idSection])




  // NO SE USA UN USEMODALFORM PORQUE INTERNAMENTE YA SE LLAMA UN CREATE
  // LA ESTRATEGIA ES CREAR UN MODAL Y DENTRO UN CREATE, SI SE CREARA UN MODALFORM, NO SE ACTUALIZAN LOS CAMPOS DEL FORM CADA VEZ QUE SE ABRE
  // POR ESO ES NECESARIO UN CREATE Y NO UN MODALFORM
  const {
    // close : closeModal,
    modalProps: createModalProps,
    formProps: createFormProps,
    show: createModalShow
  } = useModalForm({
    // } = useModal({
    action: "create"
    , resource: 'subsectionPub'
    , redirect: false
    // , warnWhenUnsavedChanges: true
    // , autoResetForm : true 
  });

  // const cerrarModal = () => {
  //   setOpenCreateModal(false)
  // }


  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: editModalShow,
} = useModalForm({
    action: "edit"
    , resource: 'sectionPub'
    , redirect: false
});

  return (
    <>
      <Layout style={{ background: colorBgContainer }} hasSider>
        <Sider width={250} style={{ background: colorBgContainer }}>
          <Menu
            mode="vertical"
            defaultSelectedKeys={[]}
            // defaultOpenKeys={['29', '230', '28']}
            style={{ height: '100%' }}
            items={itemsMenu}
            onClick={menuClick}
          />
        </Sider>
        <Content style={{ padding: '0 24px', minHeight: 280 }}>

          <EditComponentsPublication idSubsection={idSubSection} idSection={idSection}
          />
        </Content>
      </Layout>

      {

        <Modal {...createModalProps}
          // open={openCreateModal} 
          // onCancel={ ()=> setOpenCreateModal(false) } 
          // key={idSection} 
          // destroyOnClose={true}
          // width={1000}
          // footer={[
          // ]}        
          title="Create Subsección publicación"
        >

          <Cw8Create
            key={idSection}
            resourceName={'subsectionPub'}
            filterList={[
              {
                field: "sup_id_section",
                operator: "eq",
                value: idSection
              },
            ]}
            createFormProps={createFormProps}
          // isModal = {true}
          // closeModal={cerrarModal}
          ></Cw8Create>

        </Modal>




      }


            <Modal {...editModalProps}
                title="Editar Subsección"
            >
                <Cw8Edit
                    key={idSection}
                    resourceName={'sectionPub'}
                    editFormProps={editFormProps}
                    idResource={idSection}
                    modal={true}
                // closeModal={cerrarModal}
                ></Cw8Edit>
            </Modal>
    </>


  )
}